import React from "react";
import PropTypes from "prop-types";
import {
  Box,
  Stack,
  Typography,
} from "@mui/material";
import { alpha } from "@mui/material/styles";

import addressFieldUi from "./addressFieldUi";

const AddressColumnTitle = ({
  action,
  icon,
  title,
}) => (
  <Stack
    direction="row"
    spacing={0.7}
    alignItems="center"
    sx={{ minWidth: 0, flex: 1 }}
  >
    <Box
      sx={{
        width: 28,
        height: 28,
        display: "grid",
        placeItems: "center",
        flexShrink: 0,
        borderRadius: 0.95,
        bgcolor: theme =>
          alpha(
            theme.palette.primary.main,
            0.065
          ),
        color: "primary.main",
      }}
    >
      {icon}
    </Box>

    <Typography
      component="div"
      sx={{
        minWidth: 0,
        color: addressFieldUi.text,
        fontSize: 10.1,
        lineHeight: 1.2,
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: ".035em",
      }}
    >
      {title}
    </Typography>

    {action}
  </Stack>
);

AddressColumnTitle.propTypes = {
  action: PropTypes.node,
  icon: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,
};

export default AddressColumnTitle;
